import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2 } from "lucide-react";

export function SettingsTab({ settings, setSettings, saving, onSave }) {
  return (
    <div className="space-y-4 max-w-md">
      <h2 className="font-bold">Configuracoes da Plataforma</h2>
      <Card>
        <CardContent className="p-4 space-y-4">
          <div className="space-y-2">
            <label className="text-xs font-medium text-muted-foreground">
              Comissao Padrao de Novos Afiliados (%)
            </label>
            <Input
              type="number"
              value={settings.affiliate_commission_pct || 10}
              onChange={(e) => setSettings((prev) => ({ ...prev, affiliate_commission_pct: parseInt(e.target.value) || 0 }))}
              className="bg-secondary border-transparent"
              data-testid="admin-commission-input"
            />
            <p className="text-[10px] text-muted-foreground">
              Valor padrao para novos afiliados. Edite individualmente na aba Afiliados (porcentagem ou valor fixo)
            </p>
          </div>
          <div className="space-y-2">
            <label className="text-xs font-medium text-muted-foreground">Dias de Trial</label>
            <Input
              type="number"
              value={settings.default_trial_days || 30}
              onChange={(e) => setSettings((prev) => ({ ...prev, default_trial_days: parseInt(e.target.value) || 30 }))}
              className="bg-secondary border-transparent"
              data-testid="admin-trial-days-input"
            />
          </div>
          <Button className="w-full" onClick={onSave} disabled={saving} data-testid="admin-save-settings">
            {saving ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
            Salvar Configuracoes
          </Button>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="p-4 space-y-2">
          <p className="text-xs font-medium text-muted-foreground">Emails com acesso ao Admin Master</p>
          <div className="space-y-1">
            <Badge variant="outline" className="text-xs">test@test.com</Badge>
            <Badge variant="outline" className="text-xs ml-1">grupokaiso@yahoo.com</Badge>
          </div>
          <p className="text-[10px] text-muted-foreground">
            Para adicionar novos admins, edite PLATFORM_ADMIN_EMAILS no backend
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
